export default __webpack_public_path__ + "static/media/MJME.cf29a36c.mp4";